import { toLower } from 'lodash';
import moment from 'moment';

export const toHistoryItem = ({
  startSessionTime,
  stopSessionTime,
  ipAddress,
  location,
  applications
}) => ({
  sessionStart: moment.utc(startSessionTime).local(),
  sessionEnd: moment.utc(stopSessionTime).local(),
  ipAddress,
  location,
  applicationsAccessed: applications
});

const toLastAccessTime = (history = []) =>
  history.reduce((acc, { stopSessionTime, applications }) => {
    const sessionStop = stopSessionTime * 1000;
    applications.forEach(applicationName => {
      const applicationNameLowerCase = toLower(applicationName);
      const oldSessionTime = acc[applicationNameLowerCase];
      acc[applicationNameLowerCase] =
        sessionStop < oldSessionTime ? oldSessionTime : sessionStop;
    });
    return acc;
  }, {});

export const mapToSessionHistoryModel = ({ history, total }) => ({
  list: (history && history.map(toHistoryItem)) || [],
  total: parseInt(total)
});

export const mapToLastAccessTimeModel = ({ history, total }) => ({
  list: toLastAccessTime(history),
  total: parseInt(total)
});
